export default {
      id: "bell-usage",
      viewBox: "0 0 21.255 25.12",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#bell",
      toString: function () {
        return this.url;
      }
    }